import { render, staticRenderFns } from "./sendPaymentLink.vue?vue&type=template&id=4783ddf6&"
import script from "./sendPaymentLink.vue?vue&type=script&lang=js&"
export * from "./sendPaymentLink.vue?vue&type=script&lang=js&"
import style0 from "./sendPaymentLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports